// extracted by mini-css-extract-plugin
module.exports = {"container":"TCSButton_container__OOX-X","default":"TCSButton_default__2vQH8","primary":"TCSButton_primary__iVAN4","link":"TCSButton_link__10lY2"};